module.exports = __webpack_public_path__ + "static/media/Office-Intern.bbf12f80.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/Office-Intern.gif
// module id = 312
// module chunks = 0